import { CreateAsset, IAssetRecord, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportParams extends IqueryParams<{
  batch_number?: string;
  model?: string;
  asset_status?: string;
  asset_category_name?: string;
  is_assigned?: boolean;
  brand?: string;
  date_received?: string;
  distribution_status?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createAsset = async (data: CreateAsset) => {
  return apiService.apiRequest<IAssetRecord>('post', `assets`, data);
};

const getAssets = async (queryParams?: IqueryParams<{
  limit?: number, is_assigned?: boolean
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IAssetRecord[]>('get', `assets${query}`);
};

const getAsset = async (asset_id: string) => {
  return apiService.apiRequest<IAssetRecord>('get', `assets/${asset_id}`);
};

const unallocated = async (queryParams?: IqueryParams<{
  limit?: number, is_assigned?: boolean
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IAssetRecord[]>('get', `assets/unallocated${query}`);
};

const updateAsset = async (asset_id: string, data: Partial<CreateAsset>) => {
  return apiService.apiRequest<IAssetRecord>('put', `assets/${asset_id}`, data);
};

const deleteAsset = async (asset_id: string) => {
  return apiService.apiRequest<null>('delete', `assets/${asset_id}`);
};

const getDeletedAssets = async (queryParams?: { page?: number, limit?: number }) => {
  const query = buildQueryString({ isDeleted: true, ...queryParams });
  return apiService.apiRequest<IAssetRecord[]>('get', `assets${query}`);
};

const restoreAsset = async (asset_id: string) => {
  return apiService.apiRequest<IAssetRecord>('put', `assets/${asset_id}/restore`);
};

const exportAssets = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `assets/export${query}`
  );
};

export const assetApi = {
  createAsset: createAsset,
  getAssets: getAssets,
  getAsset: getAsset,
  updateAsset,
  deleteAsset,
  getDeletedAssets,
  restoreAsset,
  unallocated,
  exportAssets
};